import { type IErrorResponse } from '~types'

export const isErrorResponse = (error: unknown): error is IErrorResponse => {
  return (error as IErrorResponse).message !== undefined
}

const API_ERROR_PREFIXES =
  /^(Bad request|Permission Error|Unauthorized|Not found|Conflict|Unprocessable Entity|Bad Gateway|An error occurred):\s*/i

/**
 * Extracts the human-readable `detail` message returned by PoliAPIView error
 * responses, stripping the status prefix (e.g. "Bad request: "). Falls back to
 * the provided message when no detail is present.
 */
export const getApiErrorDetail = (error: unknown, fallback: string): string => {
  const detail = (error as { response?: { data?: { detail?: unknown } } })?.response?.data?.detail
  if (typeof detail === 'string' && detail.trim() !== '') {
    return detail.replace(API_ERROR_PREFIXES, '')
  }
  return fallback
}
